<template>
  <div id="cardClass">
    <el-row :gutter="20">
      <p class="tips">*可拖拽进行排序</p>
      <el-col :span="12">
        <div class="class">
          <el-input
            class="search"
            size="mini"
            placeholder="搜索关键字"
            v-model="searchForm.firstClass">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="getFirstClass"></i>
          </el-input>
          <div class="class-item top">一级分类</div>
          <div class="item-div">
            <draggable v-model="firstClassList" @update="datadragEndFirst" :options = "{animation:500}">
              <transition-group>
                <div v-for="item in firstClassList" @click.stop="showSecondClass(item)" :key="item.id"
                     :class="item.id != supClassId ? 'class-item' : 'class-item selected'">
                  {{item.className}}
                  <span style="font-size: 12px">商品展示</span>
                  <img v-if="item.shopDisplay == '1'" src="../assets/eye-2.png" style="width: 15px" @click.stop="changeDisplay(item,'0','shop',)"/>
                  <img v-if="item.shopDisplay == '0'" src="../assets/eye.png" style="width: 15px" @click.stop="changeDisplay(item,'1','shop')"/>
                  <span style="font-size: 12px">分类展示</span>
                  <img v-if="item.classifyDisplay == '1'" src="../assets/eye-2.png" style="width: 15px" @click.stop="changeDisplay(item,'0','classify')"/>
                  <img v-if="item.classifyDisplay == '0'" src="../assets/eye.png" style="width: 15px" @click.stop="changeDisplay(item,'1','classify')"/>
                  <i class="el-icon-edit el-icon--right" @click.stop="editClass(item,'first')"></i>
                  <i class="el-icon-delete el-icon--right" @click.stop="deleteClass(item,'first')"></i>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div class="class-item bottom" @click="addClass('first')">添加</div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="class">
          <el-input
            size="mini"
            placeholder="搜索关键字"
            v-model="searchForm.secondClass">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="getSecondClass"></i>
          </el-input>
          <div class="class-item top">二级分类</div>
          <div class="item-div">
            <draggable v-model="secondClassList" @update="datadragEndSecond" :options = "{animation:500}">
              <transition-group>
                <div class="class-item" v-for="item in secondClassList" :key="item.id">
                  {{item.className}}
                  <i class="el-icon-edit el-icon--right" @click.stop="editClass(item,'second')"></i>
                  <i class="el-icon-delete el-icon--right" @click.stop="deleteClass(item,'second')"></i>
                </div>
              </transition-group>
            </draggable>
          </div>

          <div class="class-item bottom" @click="addClass('second')">添加</div>
        </div>
      </el-col>

    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      width="30%">
      <el-input v-model="className" placeholder="请输入品类名称"></el-input>
      <span style="line-height: 40px;">品类图标</span>
      <el-upload
        ref="upload"
        action=""
        class="icon-uploader"
        :on-change="handleIconSuccess"
        :auto-upload="false"
        :show-file-list="false">
        <img v-if="iconImageUrl" :src="iconImageUrl" class="icon-img">
        <i v-else class="el-icon-plus icon-uploader-icon"></i>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click.native="addSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import axios from "axios";
  import utils from "../utils/utils";
  import draggable from 'vuedraggable';
  export default {
    name: "card-class",
    components: {
      draggable
    },
    data(){
      return{
        searchForm:{
          firstClass:"",
          secondClass:""
        },
        dialogVisible:false,
        className:"",
        iconImageUrl: '',
        iconFile:null,
        action:null,
        supClassId:0,
        firstClassList:[],
        editType:"",
        id:null,
        dialogTitle:"",
        changeIcon:false,
        secondClassList:[]
      }
    },
    created(){
      this.getFirstClass();
    },
    mounted () {
      //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
      document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    methods:{
      datadragEndFirst (evt) {
        evt.preventDefault();
        this.updateSort(this.firstClassList)
      },
      datadragEndSecond (evt) {
        evt.preventDefault();
        this.updateSort(this.secondClassList)
      },
      updateSort(classList){
        let newClassList = [];
        classList.map((item,index) => {
          newClassList.push({
            id:item.id,
            sort:index
          })
        })
        var formData = new FormData();
        formData.append("classList",JSON.stringify(newClassList))
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/classSort",
          data:formData
        })
      },
      getFirstClass(){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/queryFirstClass",
          params:{
            className:this.searchForm.firstClass
          },
          data:{},
          callback:(res => {
            this.firstClassList = res.data.list;
          })
        })
      },
      getSecondClass(){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/querySecondClass",
          params:{
            supClassId:this.supClassId,
            className:this.searchForm.secondClass
          },
          callback:(res => {
            this.secondClassList = res.data.list;
          })
        })
      },
      addClass(type){
        this.action = "add";
        this.dialogTitle = "添加品类";
        this.dialogVisible = true;
        this.editType = type;
        if(type == "first"){
          this.supClassId = 0;
        }
      },
      closeDialog(){
        this.dialogVisible = false;
        this.className = "";
        this.$refs.upload.clearFiles();
        this.iconFile = null;
        this.iconImageUrl = "";
        this.changeIcon = false;
      },
      addSure(){
        let formData = new FormData();
        if(this.changeIcon){
          formData.append("file", this.iconFile);
        }
        formData.append("className", this.className);
        formData.append("supClassId", this.supClassId);
        let url;
        if(this.action == "add"){
          url = 'api/cardManage/insertClass';
        }else{
          url = 'api/cardManage/updateClass';
          formData.append("id", this.id);
        }
        axios.post(url, formData)
          .then( response=> {
            if(response.data.code == 0){
              this.closeDialog();
              this.$message({
                message: '恭喜你，操作成功',
                type: 'success'
              });
              if(this.editType == "first"){
                this.getFirstClass()
              }else{
                this.getSecondClass(this.supClassId)
              }
            }else{
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          })
          .catch(error => {

          });
      },
      handleIconSuccess(file, fileList) {
        this.iconImageUrl = URL.createObjectURL(file.raw);
        this.iconFile = file.raw;
        this.changeIcon = true;
      },
      editClass(item,type){
        this.dialogVisible = true
        this.action = "update"
        this.dialogTitle = "编辑品类";
        this.id = item.id
        this.className = item.className
        this.iconImageUrl = "/api/"+item.icon
        this.editType = type
        if(type == "first"){
          this.supClassId = 0;
          this.secondClassList = [];
        }
      },
      deleteClass(item,type){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/deleteClass",
          params:{
            id:item.id
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message({
                message: '恭喜你，删除成功',
                type: 'success'
              });
              if(type == "first"){
                this.getFirstClass()
              }else{
                this.getSecondClass(this.supClassId)
              }
            }else{
              this.$message({
                message: res.data.msg,
                type: 'error'
              });
            }
          })
        })
      },
      showSecondClass(item){
        this.supClassId = item.id;
        this.getSecondClass(this.supClassId);
      },
      changeDisplay(item,display,type){
        utils.axiosMethods({
          method: "GET",
          url: "/api/cardManage/changeClassDisplay",
          params: {
            id: item.id,
            display: display,
            type: type
          },
          callback: (res => {
            if(res.data.code == 0){
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              if(type == 'shop'){
                item.shopDisplay = display
              }else{
                item.classifyDisplay = display
              }
            }
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #cardClass{
    height: 100%;
    .tips{
      color: red;
      margin: 0;
      padding: 0;
      line-height: 30px;
      height: 30px;
    }
    .el-row{
      height: calc(100% - 30px);
      .el-col{
        height: 100%;
        .class{
          max-width: 300px;
          margin: 0 auto;
          padding:10px 10px 62px 10px;
          height: calc(100% - 72px);
          border: solid 1px #dcdcdc;
          position: relative;
          max-height: 500px;
          .class-item{
            border: solid 1px #409EFF;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            margin-top: 10px;
            background-color: #409EFF;
            color: #fff;
          }
          .class-item[class~=selected]{
            background-color: #1f7aff;
          }
          .top{
            border: solid 1px #dcdcdc;
            color: #2c3e50;
            background-color: #fff;
          }
          .bottom{
            border: dashed 1px #dcdcdc;
            color: #2c3e50;
            background-color: #fff;
          }
          .item-div{
            height: calc(100% - 82px);
            overflow: auto;
          }
        }
      }
    }

  }
</style>
<style lang="less">
  #cardClass{
    .icon-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .icon-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .icon-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .icon-img {
      width: 60px;
      height: 60px;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cardClass.vue